/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { NavigationComponent } from '../../components/navigation/navigation.component'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'myprofile-signup-ui-layout-maintenance',
  templateUrl: './layout-maintenance.component.html',
  host: { class: 'flex-1 block min-h-full' },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NavigationComponent, RouterOutlet],
})
export class LayoutMaintenanceComponent {}
